import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import ReactDOMServer from 'react-dom/server';

import {CaretRight, LockIcon} from '../../icon';

import styles from './column-header-reorderable.module.css';

export type Direction = 'left' | 'right';

type Props = {
    text: string;
    onReorder: (arg1: Direction) => any;
    canMoveRight: boolean;
    canMoveLeft: boolean;
    isFixed: boolean;
    moveRightTooltipText?: string;
    moveLeftTooltipText?: string;
    lockedTooltipText?: string | React.ReactNode;
};

export function ColumnHeaderReorderable(props: Props) {
    const {
        text,
        onReorder,
        canMoveRight,
        canMoveLeft,
        isFixed,
        moveRightTooltipText = 'Move right',
        moveLeftTooltipText = 'Move left',
        lockedTooltipText = 'This column cannot be reordered',
    } = props;

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    return (
        <div className={styles['column-header-reorderable']}>
            {canMoveLeft && (
                <button
                    onClick={() => onReorder('left')}
                    data-tip={moveLeftTooltipText}
                    className={styles['left-icon']}
                >
                    <CaretRight size={18} style={{transform: 'rotate(0.5turn)'}} />
                </button>
            )}
            <div className={styles.text}>{text}</div>
            {canMoveRight && (
                <button
                    onClick={() => onReorder('right')}
                    data-tip={moveRightTooltipText}
                    className={styles['right-icon']}
                >
                    <CaretRight size={18} />
                </button>
            )}
            {isFixed && (
                <div
                    data-html={typeof lockedTooltipText !== 'string'}
                    data-tip={
                        typeof lockedTooltipText === 'string'
                            ? lockedTooltipText
                            : // @ts-expect-error
                              ReactDOMServer.renderToString(lockedTooltipText)
                    }
                    className={styles['lock-icon']}
                >
                    <LockIcon size={13} />
                </div>
            )}
        </div>
    );
}
